import { useState } from "react";

import styles from "./amazonOverview.module.css";

/** A step's or milestone's risks: the first two, the rest behind "See more". */
export const RiskList = ({ causes }: { causes: string[] }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ul className={styles.riskList}>
        {(open ? causes : causes.slice(0, 2)).map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      {causes.length > 2 && (
        <button
          type="button"
          className={`${styles.linkButton} ${styles.riskMore}`}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {open ? "See less" : "See more"}
        </button>
      )}
    </>
  );
};
